"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleResurrectSpectrumFromJcamp = exports.handleResurrectSpectrumFromRanges = void 0;
const Spectrum1D_1 = require("../../../data/data1d/Spectrum1D");
const generateSpectrumFromRanges_1 = require("../../../data/data1d/Spectrum1D/ranges/generateSpectrumFromRanges");
const Zoom1DManager_1 = require("../helper/Zoom1DManager");
const DomainActions_1 = require("./DomainActions");
function handleResurrectSpectrumFromJcamp(draft, action) {
    const { ranges } = action.payload;
    let { spectrum } = action.payload;
    spectrum = {
        ...spectrum,
        ranges: {
            ...spectrum.ranges,
            values: (0, Spectrum1D_1.mapRanges)(ranges, spectrum),
        },
        display: {
            ...spectrum.display,
            ...(0, Spectrum1D_1.get1DColor)(spectrum.display, draft.usedColors),
        },
    };
    draft.data.push(spectrum);
    (0, DomainActions_1.setDomain)(draft);
    (0, DomainActions_1.setIntegralsYDomain)(draft, [spectrum]);
    (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8, spectrumID: spectrum.id });
}
exports.handleResurrectSpectrumFromJcamp = handleResurrectSpectrumFromJcamp;
function handleResurrectSpectrumFromRanges(draft, action) {
    const { ranges, info } = action.payload;
    const datum = (0, generateSpectrumFromRanges_1.generateSpectrumFromRanges)(ranges, info, draft.usedColors);
    if (datum) {
        draft.data.push(datum);
        (0, DomainActions_1.setDomain)(draft, { isYDomainShared: false });
        (0, DomainActions_1.setIntegralsYDomain)(draft, [datum]);
        (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8, spectrumID: datum.id });
    }
}
exports.handleResurrectSpectrumFromRanges = handleResurrectSpectrumFromRanges;
